import React, { useRef } from 'react'
import {
  UserFeedback,
  Mtds,
  HouseIcon,
  ListChecksIcon,
  GearIcon,
  TestTubeIcon,
  useMtdsAppSticky
} from 'prove-common'
import { NavLink } from 'react-router'

export const SideBar = () => {
  const stickyRef = useRef<HTMLElement>(null)
  useMtdsAppSticky(stickyRef)

  return (
    <>
      <Mtds.App.Toggle id={'mtds-app-toggle'} />
      <Mtds.App.Sidebar>
        <Mtds.App.Sticky as='menu' ref={stickyRef}>
          <li>
            <Mtds.Button
              as={NavLink}
              data-tooltip='Hjem'
              to='/home'
              data-cy='bottom-nav-home'
            >
              <HouseIcon />
            </Mtds.Button>
          </li>
          <li>
            <Mtds.Button
              as={NavLink}
              data-tooltip='Oppgaver'
              to='/tasks'
              data-cy='bottom-nav-tasks'
            >
              <ListChecksIcon />
            </Mtds.Button>
          </li>
          <li>
            <Mtds.Button
              as={NavLink}
              data-tooltip='Prøver'
              to='/samples'
              data-cy='bottom-nav-samples'
            >
              <TestTubeIcon />
            </Mtds.Button>
          </li>
          <li>
            <Mtds.Button
              as={NavLink}
              data-tooltip='Innstillinger'
              to='/settings'
              data-cy='bottom-nav-settings'
            >
              <GearIcon />
            </Mtds.Button>
          </li>
        </Mtds.App.Sticky>
      </Mtds.App.Sidebar>
      <UserFeedback appName='proveta' />
    </>
  )
}
